import { getAccountSetup } from '../actions';
import * as types from './types';
import { loading } from 'State/actions';

export const changeStudentBalance = (TotalPay, TotalPurchase) => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.ACCOUNT_SETUP_STUDENT_BALANCE_SUBMITTING, true));

    try {
      const { data } = getState().AccountSetupState.studentBalance;
      await MPWWebApi.postGenericInsertUpdate('student/balance', {
        ...data,
        TotalPay,
        TotalPurchase,
      });

      dispatch({
        type: types.ACCOUNT_SETUP_POST_STUDENT_BALANCE_SUCCESS,
      });
      dispatch(getAccountSetup({}));
    } catch (error) {
      dispatch({
        type: types.ACCOUNT_SETUP_STUDENT_BALANCE_ERROR,
        payload: error,
      });
    }

    dispatch(loading(types.ACCOUNT_SETUP_STUDENT_BALANCE_SUBMITTING, false));
  };
};

export const getStudentBalance = idSeed => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.ACCOUNT_SETUP_STUDENT_BALANCE_FETCHING, true));

    try {
      const response = await MPWWebApi.getGeneric(`student/balance/${idSeed}`);

      dispatch({
        type: types.ACCOUNT_SETUP_GET_STUDENT_BALANCE,
        payload: response.data.Data,
      });
    } catch (error) {
      dispatch({
        type: types.ACCOUNT_SETUP_STUDENT_BALANCE_ERROR,
        payload: error,
      });
    }

    dispatch(loading(types.ACCOUNT_SETUP_STUDENT_BALANCE_FETCHING, false));
  };
};

export const clearChangeBalanceError = () => {
  return {
    type: types.ACCOUNT_SETUP_CLEAR_STUDENT_BALANCE_ERROR,
  };
};

export const resetChangeBalance = () => {
  return {
    type: types.ACCOUNT_SETUP_STUDENT_BALANCE_RESET,
  };
};



// WEBPACK FOOTER //
// ./src/pages/accountsetup/state/changebalance/actions.js